var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "share_svg__\\uB808\\uC774\\uC5B4_1",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".share_svg__st0{fill:none}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "share_svg__st0",
    d: "M29-12.26h11.43v-5.72h-9.87L29-16.42zM29-16.42l1.56-1.56H29z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 16c-1.2 0-2.27.54-3 1.38l-9.09-4.54c.06-.27.09-.55.09-.84s-.03-.57-.09-.84L17 6.62c.73.84 1.8 1.38 3 1.38 2.21 0 4-1.79 4-4s-1.79-4-4-4a3.999 3.999 0 0 0-3.91 4.84L7 9.38C6.27 8.54 5.2 8 4 8c-2.21 0-4 1.79-4 4s1.79 4 4 4c1.2 0 2.27-.54 3-1.38l9.09 4.54A3.999 3.999 0 0 0 20 24c2.21 0 4-1.79 4-4s-1.79-4-4-4z"
  })));
};
export default SvgShare;